import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='CardNetwork.visa' mdxType="Item"></Item>
    <Item title='CardNetwork.masterCard' mdxType="Item"></Item>
    <Item title='CardNetwork.amex' mdxType="Item"></Item>
    <Item title='CardNetwork.diners' mdxType="Item"></Item>
    <Item title='CardNetwork.discover' mdxType="Item"></Item>
    <Item title='CardNetwork.jcb' mdxType="Item"></Item>
    <Item title='CardNetwork.unionpay' mdxType="Item"></Item>
    <Item title='CardNetwork.maestro' mdxType="Item"></Item>
    <Item title='CardNetwork.elo' mdxType="Item"></Item>
    <Item title='CardNetwork.mir' mdxType="Item"></Item>
    <Item title='CardNetwork.hiper' mdxType="Item"></Item>
    <Item title='CardNetwork.hipercard' mdxType="Item"></Item>
    <Item title='CardNetwork.unknown' mdxType="Item">
    This network has a string value of 'OTHER' which matches what is returned by Primer APIs when a network is not identifiable for a given card. Passing this will return a generic card icon.
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      